import { render, staticRenderFns } from "./OrderPersonInfo.vue?vue&type=template&id=aed2159e&scoped=true"
import script from "./OrderPersonInfo.vue?vue&type=script&lang=js"
export * from "./OrderPersonInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderPersonInfo.vue?vue&type=style&index=0&id=aed2159e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed2159e",
  null
  
)

export default component.exports